import SalesEvolution from "./SalesEvolution";
import TopProdutos from "./TopProdutos";
import TopSalespersons from "./TopSalespersons";
import SalesByDepartmentChart from "./SalesByDepartmentChart";
import TopProdutosPorMargem from "./TopProdutosPorMargem";
import ProdutosGiroCaindo from "./ProdutosGiroCaindo";
import TicketMedioPorVendedor from "./TicketMedioPorVendedor";
import PercentualFormaPagamento from "./PercentualFormaPagamento";
import DashSectionTitle from "./v2/DashSectionTitle";

const SalesArea = () => {
  return (
    <div id="sales">
      <DashSectionTitle title="Vendas" subtitle="Desempenho de vendas, produtos e equipe" />

      <div className="dash-grid dash-grid-2 mb-3">
        <SalesEvolution />
        <TopProdutos />
      </div>

      <div className="dash-grid dash-grid-2 mb-3">
        <TopSalespersons />
        <TicketMedioPorVendedor />
      </div>

      <div className="dash-grid mb-3">
        <SalesByDepartmentChart />
      </div>

      <div className="dash-grid dash-grid-3">
        <TopProdutosPorMargem />
        <ProdutosGiroCaindo />
        <PercentualFormaPagamento />
      </div>
    </div>
  );
};

export default SalesArea;
